<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>
        Onboarding per BA
      </mat-card-title>
      <mat-select class="month-select"
                  [(ngModel)]="currentMonth"
                  placeholder="Month"
                  (selectionChange)="filterByMonth($event.value)">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let i of months"
                    [value]="i">{{i}}</mat-option>
      </mat-select>
    </mat-card-header>
    <mat-card-content>
      <ifb-vertical-stacked-bar-chart [options]="chartData.options"
                                      [view]="chartData.view"
                                      [data]="chartData.data">
      </ifb-vertical-stacked-bar-chart>
    </mat-card-content>
  </mat-card>
</ifb-card>
